












































import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IClearanceApproval } from "@/models/clearance-approval.entity";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";

@Component({
  components: { PreselectTemplateCard },
  filters: {}
})
export default class ReportClearanceApprovalRequestDialog extends mixins(PermissionMixin, RulesMixin)
  implements IDialog {
  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: false }) clearanceApproval!: IClearanceApproval;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get vehicle() {
    return PartnerModule.report.vehicle;
  }

  get context() {
    const firstSharedContent = this.clearanceApproval?.sharedContent?.[0];
    return {
      partner: this.partner,
      report: this.report,
      vehicle: this.vehicle,
      clearanceApproval: this.clearanceApproval,
      url: {
        sharing: firstSharedContent?.url ?? ""
      }
    };
  }

  get validForm() {
    return this.report.workshopCompanyId;
  }

  get myUserId() {
    return UserModule.userId;
  }

  async sendMail() {
    await this.templateCard?.send();
    await this.clearanceApproval.updatePartial({
      status: RequestStatusEnum.REQUESTED
    });
    this.close();
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }
}
